import { render } from "./WritingTranslation.vue?vue&type=template&id=22271414"
import script from "./WritingTranslation.vue?vue&type=script&lang=js"
export * from "./WritingTranslation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__